module.exports = __webpack_public_path__ + "static/portail-intranet-extranet.a210a769.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/portail-intranet-extranet.jpg
// module id = 846
// module chunks = 267660657819475